import { queryKeys, queryValues } from '~/routes/query-params';

import { safeFormatDate } from '../earnings-shared/utils';

export const formatCorporateActionDate = (
  value: string | undefined,
  pattern = 'MMM d, yyyy'
): string => {
  if (!value) {
    return '';
  }

  return safeFormatDate(value.slice(0, 10), pattern) || value;
};

export const formatCorporateActionShareRatio = (
  numNewShares: number | undefined,
  numOldShares: number | undefined
) =>
  numNewShares !== undefined && numOldShares !== undefined
    ? `${numNewShares} : ${numOldShares}`
    : '';

export const getCorporateActionDrawerParams = (
  params: Record<string, string | null>
) => {
  const id = params[queryKeys.corporateActionId] ?? '';

  return {
    isOpen:
      params[queryKeys.activeDrawer] === queryValues.corporateActionDrawer &&
      !!id,
    id,
  };
};
